var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCustomSliderArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 16,
    viewBox: "0 0 9 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.07275 8L8.42954 7.6497C8.62049 7.8442 8.62049 8.1558 8.42954 8.3503L8.07275 8ZM0.843244 1.3503C0.649781 1.15325 0.652686 0.836681 0.849731 0.643218C1.04678 0.449755 1.36335 0.45266 1.55681 0.649705L0.843244 1.3503ZM1.55681 15.3503C1.36335 15.5473 1.04678 15.5502 0.849731 15.3568C0.652686 15.1633 0.649781 14.8468 0.843244 14.6497L1.55681 15.3503ZM7.71597 8.3503L0.843244 1.3503L1.55681 0.649705L8.42954 7.6497L7.71597 8.3503ZM8.42954 8.3503L1.55681 15.3503L0.843244 14.6497L7.71597 7.6497L8.42954 8.3503Z",
    fill: "#F7F7FC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomSliderArrow);
export default __webpack_public_path__ + "static/media/customSliderArrow.a1177d16862b00b5d8b2b932fead29e9.svg";
export { ForwardRef as ReactComponent };